import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Flame, Pill } from "lucide-react";

const TEAL = "#0D9488";

/** Compact Profile badge — consecutive-day supplement stack streak. */
export default function SupplementStreakBadge() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const { data: d } = await api.get("/supplement-streak");
        if (!cancel) setData(d);
      } catch {
        if (!cancel) setData({ current_streak: 0, best_streak: 0, total: 0 });
      }
    })();
    return () => { cancel = true; };
  }, []);

  if (!data) return <div className="h-24 bg-white border border-slate-200 rounded-xl animate-pulse" />;
  if (data.total === 0) return null; // hide entirely for users who haven't added supplements yet

  const cur = data.current_streak;
  const best = data.best_streak;
  const hot = cur >= 3;

  return (
    <div
      className="bg-white border border-slate-200 rounded-xl p-5 flex items-center gap-4"
      data-testid="supp-streak-badge"
    >
      <div
        className="w-14 h-14 rounded-xl flex items-center justify-center shrink-0"
        style={{ background: hot ? "linear-gradient(135deg,#F0FDFA 0%,#CCFBF1 100%)" : "#F1F5F9" }}
      >
        {hot ? (
          <Flame className="w-7 h-7" style={{ color: TEAL }} strokeWidth={2.2} />
        ) : (
          <Pill className="w-7 h-7 text-slate-400" strokeWidth={2.2} />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] font-semibold uppercase tracking-widest" style={{ color: TEAL }}>
          Supplement Streak
        </div>
        <div className="flex items-baseline gap-1.5 mt-0.5">
          <span className="font-display font-bold text-slate-900 text-3xl tabular-nums" data-testid="supp-streak-current">{cur}</span>
          <span className="text-sm text-slate-500 font-semibold">
            day{cur === 1 ? "" : "s"} at 100%
          </span>
        </div>
        <div className="text-xs text-slate-500 mt-0.5 tabular-nums">
          Best: <span className="font-semibold text-slate-700" data-testid="supp-streak-best">{best}</span> · Stack size: {data.total}
        </div>
      </div>
    </div>
  );
}
